export default "__VITE_ASSET__BUNj1NP9__"